import React from "react"
import { Card, CardBody, Row, Col, Badge, Progress, Button } from "reactstrap"
import { Link } from "react-router-dom"

const ContentModerationPanel = () => {
  // Dummy data for content moderation - replace with real API data
  const moderationData = {
    flaggedPosts: 15,
    reportedUsers: 8,
    pendingReviews: 23,
    autoModerated: 142,
    todayActions: 67,
    contentTypes: [
      { type: "Inappropriate Content", count: 12, severity: "high" },
      { type: "Spam", count: 8, severity: "medium" },
      { type: "Harassment", count: 3, severity: "high" },
      { type: "Copyright", count: 2, severity: "medium" }
    ]
  }

  const getSeverityColor = (severity) => {
    return severity === 'high' ? 'danger' : severity === 'medium' ? 'warning' : 'info'
  }

  return (
    <Card className="border-0 shadow-sm">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h4 className="card-title mb-0">Content Moderation</h4>
          <Badge color="warning" className="badge-soft">
            {moderationData.pendingReviews} Pending
          </Badge>
        </div>

        <Row className="mb-3">
          <Col sm={3}>
            <div className="text-center">
              <h4 className="text-danger">{moderationData.flaggedPosts}</h4>
              <p className="text-muted mb-0 font-size-13">Flagged Posts</p>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-center">
              <h4 className="text-warning">{moderationData.reportedUsers}</h4>
              <p className="text-muted mb-0 font-size-13">Reported Users</p>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-center">
              <h4 className="text-success">{moderationData.autoModerated}</h4>
              <p className="text-muted mb-0 font-size-13">Auto Moderated</p>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-center">
              <h4 className="text-info">{moderationData.todayActions}</h4>
              <p className="text-muted mb-0 font-size-13">Today's Actions</p>
            </div>
          </Col>
        </Row>

        <div className="mb-3">
          <h6 className="mb-3">Content Issues by Type</h6>
          {moderationData.contentTypes.map((item, index) => (
            <div key={index} className="d-flex align-items-center justify-content-between mb-2">
              <div className="d-flex align-items-center">
                <Badge color={getSeverityColor(item.severity)} className="badge-soft me-2">
                  {item.severity}
                </Badge>
                <span className="font-size-14">{item.type}</span>
              </div>
              <div className="d-flex align-items-center">
                <span className="text-muted me-3">{item.count}</span>
                <div style={{ width: '60px' }}>
                  <Progress 
                    value={(item.count / 15) * 100} 
                    color={getSeverityColor(item.severity)} 
                    className="progress-sm"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Add more content to balance with AdminActionCenter */}
        <div className="mb-3">
          <h6 className="mb-3">Moderation Statistics</h6>
          <div className="row">
            <div className="col-6">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="font-size-13">Resolution Rate</span>
                <span className="text-success font-weight-bold">94%</span>
              </div>
              <Progress value={94} color="success" className="progress-sm mb-2" />
            </div>
            <div className="col-6">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="font-size-13">Response Time</span>
                <span className="text-info font-weight-bold">2.3h</span>
              </div>
              <Progress value={85} color="info" className="progress-sm mb-2" />
            </div>
          </div>
        </div>

        <div className="d-flex gap-2">
          <Button color="danger" size="sm" outline>
            <i className="mdi mdi-flag me-1"></i>
            Review Flagged
          </Button>
          <Button color="warning" size="sm" outline>
            <i className="mdi mdi-account-alert me-1"></i>
            User Reports
          </Button>
          <Link to="/deleted-gabs" className="btn btn-info btn-sm">
            <i className="mdi mdi-delete me-1"></i>
            Deleted Content
          </Link>
        </div>
      </CardBody>
    </Card>
  )
}

export default ContentModerationPanel